import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["links", "template"];

  addAssociation(e) {
    e.preventDefault();

    const content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );

    this.linksTarget.insertAdjacentHTML("beforebegin", content);
  }
}
